import React, { Component } from 'react';
import Pusher from 'pusher-js';
import {format} from "react-string-format";

class GameChat extends Component {
    constructor(props) {
        super(props);

        this.state = {
            comments: [],
            generalData: null,
            newComments: [],
        };
    }

    loadChat(){
        this.setState({
            comments: []
        })

        fetch(process.env.REACT_APP_API_URL + "/chat/game/"+this.props.gameId.toString(), {
            headers: {'Content-Type':'application/json', "Authorization": `Bearer ${sessionStorage.getItem('token')}`}
        })
            .then(res => res.json())
            .then(
                (result) => {
                    this.setState({
                        isLoaded: true,
                        generalData: result.chat,
                        comments: result.messages
                    });
                },

                (error) => {
                    this.setState({
                        isLoaded: true,
                        error
                    });
                }
            )
    }

    componentDidMount() {
        this.loadChat();

        this.pusher = new Pusher('dc9e7b617eeeb48fb3e4', {
            cluster: 'eu',
        });
        this.channel = this.pusher.subscribe('easy-street-api.chat.'+this.props.chatId.toString());

        this.channel.bind('pusher:subscription_succeeded', () => {
            console.log('subscribed to pusher channel');
        });

        this.channel.bind('NewComment', data => {
            this.loadChat();
        });
    }

    sendMessage(e){
        e.preventDefault();

        const body = {'message': e.target.message.value, 'user_id': this.props.userId};
        console.log(body);

        fetch(format(process.env.REACT_APP_API_URL + '/chat/{0}/message', this.props.chatId), {
            method: "POST",
            body: JSON.stringify(body),
            headers: {'Content-Type':'application/json', "Authorization": `Bearer ${sessionStorage.getItem('token')}`},
        }).then(res => res.json())
            .then(
                (result) => {},
            )

        e.target.message.value = "";
    }

    render() {
        // use the state to render the comments in your component
        const { comments } = this.state;

        let commentsFormatted = Array.from(new Set(comments)).sort((a,b) => (a.id > b.id) ? -1 : ((b.id > a.id) ? 1 : 0));

        return (
            <div style={{
                height: 300,
                overflowY: "auto"
            }} class="alert alert-dark">
                <form class="row" onSubmit={this.sendMessage.bind(this)}>
                    <div class="col-sm-5"><input class="form-control" type="text" name="message"/></div>
                    <div className="col-sm-2"><input class="btn btn-outline-dark" type="submit" value="Send"/></div>
                </form>
                <h4>Comments:</h4>
                <div class="alert alert-dark">
                    {commentsFormatted.map(comment => (
                        <div align={comment.user.first_name === this.props.userName ? "right" : "left"} key={comment.user_id + comment.message + comment.chat_id}>
                            <span style={{
                                backgroundColor: "#b3ccff",
                                width: 200,
                                borderRadius: 5,
                                paddingInline: 10,
                                paddingBlock: 10,
                                marginBottom: 20,
                                marginTop: 20,
                            }}>
                                {
                                    comment.user.first_name === this.props.userName ? comment.message : comment.user.first_name + ": " + comment.message
                                }
                                </span>
                            <br/>
                            <br/>
                        </div>
                    ))}
                </div>
            </div>
        );
    }
}

export default GameChat;
